import { useRef, useState } from "react";
import { Btn } from "./ui/Button";

interface Props {
  accept: string;
  multiple?: boolean;
  title: string;
  hint: string;
  onFiles: (files: FileList) => void;
}

export function FileDropzone({ accept, multiple, title, hint, onFiles }: Props) {
  const [dragging, setDragging] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div
      className={`text-center rounded-lg py-11 px-6 transition-colors duration-150 border-[1.5px] border-dashed ${
        dragging ? "border-rs-green bg-rs-green/5" : "border-rs-jet-light bg-rs-off-black"
      }`}
      onDragEnter={(e) => { e.preventDefault(); setDragging(true); }}
      onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
      onDragLeave={(e) => { e.preventDefault(); setDragging(false); }}
      onDrop={(e) => {
        e.preventDefault();
        setDragging(false);
        if (e.dataTransfer.files.length) onFiles(e.dataTransfer.files);
      }}
    >
      <span className="material-symbols-sharp text-[34px] text-rs-dark-green">upload_file</span>
      <h3 className="mt-3 mb-1.5">{title}</h3>
      <p className="text-rs-light-gray text-[13px] mb-[18px]">{hint}</p>
      <Btn onClick={() => inputRef.current?.click()}>
        <span className="material-symbols-sharp">folder_open</span>Choose {multiple ? "Files" : "a File"}
      </Btn>
      <input
        ref={inputRef}
        type="file"
        className="hidden"
        accept={accept}
        multiple={multiple}
        onChange={(e) => {
          if (e.target.files?.length) onFiles(e.target.files);
          e.target.value = "";
        }}
      />
    </div>
  );
}
